import * as React from 'react';
import strings from './strings';
import { FormattedCurrency } from '../common/FormattedCurrency';
import DetailsCard from '../common/DetailsCard';
import LabeledValue from '../common/LabeledValue';
import './style/index.scss';
export const CompensationCard = (props) => {
    const { pay, currency, hourly, payEffectiveDate, dateFormatter, currencyFormatter } = props;
    const hasValue = pay != null;
    const effectiveDateText = hasValue ?
        (payEffectiveDate ?
            (React.createElement("div", { className: "compensation-card__effective-date" },
                strings.payEffectiveDate,
                React.createElement("br", null),
                dateFormatter(payEffectiveDate, 'MMM Do, YYYY'))) :
            null) :
        React.createElement("span", null, strings.noPayData);
    const value = hasValue ?
        (React.createElement("div", { className: "compensation-card__amount" },
            React.createElement(FormattedCurrency, { val: pay, currency: currency, formatFunc: currencyFormatter, sensitiveValue: true }),
            hourly ? ` ${strings.perHour}` : '')) :
        (React.createElement("div", { className: "compensation-card__amount" },
            React.createElement("span", null, strings.notApplicable)));
    return (React.createElement(DetailsCard, { className: "compensation-card", title: strings.cardTitle },
        React.createElement(LabeledValue, { label: effectiveDateText, value: value })));
};
export default CompensationCard;
